import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DealerInfoModel } from './dealer-info.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DealerInfoService {

  constructor(private readonly http: HttpClient) {
  }

  getDealers(q: string) {
    const params = {
      q
    };

    return this.http.get<DealerInfoModel[]>('dealers/info/', { params })
      .pipe(
        map(response => response ? (response as any[]).map(element => DealerInfoModel.fromJSON(element)) : null)
      );
  }
}
